import state from './moduleMethodState';
import getters from './moduleMethodGetters';
import mutations from './moduleMethodMutations';
import actions from './moduleMethodActions';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
